module.exports = __webpack_public_path__ + "f74217ee279b85157943ee0c1b6ef65f.pdf";